import { CircleIcon, Flex, Text } from '@shared/components';

export type QuestionUsageStatusProps = { used: true; questionNo: number } | { used: false };

export default function QuestionUsageStatus(props: Readonly<QuestionUsageStatusProps>) {
  const { used: isUsed } = props;

  return (
    <Flex sx={{ alignItems: 'center', gap: (theme) => theme.spacing(2) }}>
      <CircleIcon
        sx={{
          color: (theme) => (isUsed ? theme.palette.grey[400] : theme.palette.success.main),
          width: '10px',
          height: '10px',
        }}
      />
      <Text>{isUsed ? `ใช้แล้ว (ข้อที่ ${props.questionNo})` : 'พร้อมใช้งาน'}</Text>
    </Flex>
  );
}
